import { SimulationActionTypes, UpdateSimulationInputPayload } from 'store/simulation/actions/types'

export const UPDATE_SIMULATION_INPUT = 'SIMULATION/UPDATE_INPUT'

export const updateSimulationInput = ({ key, value }: UpdateSimulationInputPayload): SimulationActionTypes => {
  return { type: UPDATE_SIMULATION_INPUT, key, value }
}
